import { api } from './networkService';

class ExpenseTypeService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/expense/expense-type`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch expense type error:', error);
            throw error;
        }
    }

    static async fetchAll() {
        try {
            const response = await api.get(`api/user/expense/expense-type`);
            return response.data;
        } catch (error) {
            console.error('Fetch expense type error:', error);
            throw error;
        }
    }

    static async add(expenseType) {
        try {
            const cleanedExpenseType = Object.fromEntries(
                Object.entries(expenseType).filter(([_, value]) => value && value !== '')
            );
            const response = await api.post(`api/user/expense/expense-type`, cleanedExpenseType);
            return response;
        } catch (error) {
            console.error('Add expense type error:', error);
            throw error;
        }
    }

    static async update(expenseType) {
        try {
            const { id, ...info } = expenseType;
            const cleanedExpenseType = Object.fromEntries(
                Object.entries(info).filter(([_, value]) => value && value !== '')
            );
            const response = await api.put(`api/user/expense/expense-type/${id}`, cleanedExpenseType);
            return response;
        } catch (error) {
            console.error('Update expense type error:', error);
            throw error;
        }
    }

    static async delete(id) {
        try {
            const response = await api.delete(`api/user/expense/expense-type/${id}`);
            return response;
        } catch (error) {
            console.error('Delete expense type error:', error);
            throw error;
        }
    }
}

export default ExpenseTypeService;
